import IComponent from "components/commons/IComponent";
import "./MainPage.scoped.css";

class InfoBar extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      mapPosition: null,
      mapProperty: null,
      mapViewRef: null,
    };
  }
  componentDidMount() {}
  componentDidUpdate(prevProp, prevState) {
    if (prevProp.mapView == this.props.mapView) return;
    let vm = this;
    let view = this.props.mapView;
    if (this.props.mapType == 2)
      view.watch("extent", function(newV, oldV) {
        vm.setState({
          mapProperty: {
            scale: view.scale,
            extent: newV.toJSON(),
          },
        });
      });
    else
      vm.setState({
        mapProperty: null,
      });
    view.on("pointer-move", function(evt) {
      var mapPointResult = view.toMap(evt);
      vm.setState({
        mapPosition: mapPointResult ? mapPointResult.toJSON() : null,
      });
    });
  }
  componentWillUnmount() {}
  render() {
    let { mapPosition, mapProperty } = this.state;
    return (
      <div className="bottomBar">
        <div>
          {mapPosition ? (
            `Position: ${mapPosition.x.toFixed(0)}E ${mapPosition.y.toFixed(
              0
            )}N`
          ) : (
            <span>Position: Temporary Unavailable</span>
          )}
          {mapProperty ? (
            ` | Scale: 1:${mapProperty.scale.toFixed(
              0
            )} | Min: ${mapProperty.extent.xmin.toFixed(
              0
            )}E ${mapProperty.extent.ymin.toFixed(
              0
            )}N Max: ${mapProperty.extent.xmax.toFixed(
              0
            )}E ${mapProperty.extent.ymax.toFixed(0)}N `
          ) : (
            <span />
          )}
        </div>
        <div>&copy; The Government of the Hong Kong SAR</div>
      </div>
    );
  }
}

export default InfoBar;
